import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .EditCommissionForm {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: rem(25px);

    .EditCommissionForm__line {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      margin: rem(10px 0);

      &:last-child {
        margin-top: rem(30px);
      }

      span,
      :global(.StatusCell),
      :global(.ReduxTextField),
      :global(.DefaultButton) {
        flex: 1;
      }

      :global(.ReduxTextField),
      :global(.ReduxTextField div) {
        max-height: 40px;
      }

      :global(.ReduxTextField input) {
        max-height: 40px;
        padding: rem(10px);
      }

      :global(.DefaultButton) {
        width: 120px;
        &:first-child {
          margin-right: rem(${isRTL ? '0' : '50px'});
          margin-left: rem(${isRTL ? '50px' : '0'});

          @include respond-to(xs) {
            margin-right: rem(${isRTL ? '0' : '10px'});
            margin-left: rem(${isRTL ? '10px' : '0'});
          }
        }
      }
    }

    .formError {
      align-self: flex-start;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    .EditCommissionForm__title {
      color: ${colors.gray.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
